<!-- =========================================================================================
  File Name: UserFileSidebar.vue
  Description: User File details - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t('USER_FILE_DETAIL')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('FILE_NAME')}}</small>
          <p class="font-semibold text-lg text-right file_name">{{ userFile.fileName }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('USER_ID')}}</small>
          <p class="font-semibold text-lg text-right">{{ user.userId }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('DEVICE_UUID')}}</small>
          <p class="font-semibold text-lg text-right">{{ userFile.deviceUUID }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('EVENT_FOLDER')}}</small>
          <p class="font-semibold text-lg text-right">{{ userFile.eventFolder }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('DEVICE_CHANNEL')}}</small>
          <p class="font-semibold text-lg text-right">{{ $t(getDeviceChannelCode(userFile.deviceChannelCode)) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('S3_UPLOAD_YN')}}</small>
          <p class="font-semibold text-lg text-right">{{ $t(setS3UploadResult(userFile.s3UploadYn)) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('DOWNLOAD_COUNT')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(userFile.downloadCount)" class="edit-icon" />
          </small>
          <p class="text-right font-semibold text-lg">{{ userFile.downloadCount }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('FILE_SIZE')}}</small>
          <p class="font-semibold text-lg text-right">{{ userFile.fileSize.toLocaleString() }} bytes</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('RECORD_DATE')}}</small>
          <p class="font-semibold text-lg text-right">{{ setRecordDate(userFile.recordDate) }} {{ setRecordTime(userFile.recordTime) }}</p>
        </div>
      </div>
    </VuePerfectScrollbar>

    
    <vs-popup class="sidebar-popup" classContent="popup-example" :title="this.$t('EDIT_DOWNLOAD_COUNT')" :active.sync="editPopup">
      <div>
			<vs-input-number color="danger" min="0" max="5" v-model="downloadCount" class="download-count-button"/>
			</div>
      <vs-divider />
      <div class="float-right">
        <vs-button @click="openConfirm()" color="primary" type="filled">{{this.$t('SUBMIT')}}</vs-button>
        <vs-button @click="editPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
      </div>

      <vs-popup class="sidebar-popup"  :title="this.$t('CONFIRM')" :active.sync="confirmPopup">
        <p>{{this.$t('SUBMIT_CONFIRM_MESSAGE')}}</p>
        <div class="float-right">
          <vs-button @click="acceptEdit()" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
          <vs-button @click="confirmPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return

      let { user, userFile } = JSON.parse(JSON.stringify(this.data))
      this.user = user
      this.userFile = userFile
      this.$validator.reset()
      
    },
  },
  data() {
    return {

      editPopup: false,
      confirmPopup: false,

      user:{
        userId: "",
      },
      userFile:{
        deviceChannelCode: "",
        deviceUUID:"",
        downloadCount:"",
        eventFolder:"",
        fileName:"",
        fileSize:"",
        localFullPath:"",
        recordDate:"",
        recordTime:"",
        s3UploadYn:"",
        seq:"",
        uploaderCode:"",
        userUUID:""
      },

      downloadCount:'',

      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
  },
  methods: {
    getUploaderCode(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.uploaderCode.properties[code].name
    },
    getDeviceChannelCode(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.deviceChannelCode.properties[code].name
    },
    setS3UploadResult(result){
      if (result === "Y") return "UPLOADED"
      if (result === "N") return "NOT_UPLOADED"
      if (result === "E") return "UPLOAD_ERROR"
    },
    setRecordDate(date){
      return date.substr(0,4)+"-"+date.substr(4,2)+"-"+date.substr(6,2)
    },
    setRecordTime(time){
      return time.substr(0,2)+":"+time.substr(3,2)+":"+time.substr(6,2)+time.substr(10,2)
    },
    editData(data){
      this.downloadCount = data
      this.editPopup = true
    },
    openConfirm() {
      this.confirmPopup = true
    },
    acceptEdit(){
      this.$vs.loading()

      const obj = {
        userUUID: this.userFile.userUUID,
        seq: this.userFile.seq,
        downloadCount: this.downloadCount
      }

      this.$store.dispatch("dataUserFile/updateUserFileDownloadCount", obj)
      .then(() => {
        this.close()
        this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_FILE_DOWNLOAD_COUNT_SUCCESS"))
        this.$parent.$refs.userFileTable.getData()
      })
      .catch(error => { 
        this.close()
        this.errorAlert(this.$t("ERROR"), error.message)
        
      })
    },
    close(){
      this.confirmPopup = false
      this.editPopup = false
      this.$vs.loading.close()
      this.$emit('closeSidebar')
    }
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.detail-list{
  border-bottom:1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0;
}

.download-count-button{
  background: #fff;
}

.edit-icon svg{
  padding-top: 3px !important;
}

.file_name{
  word-wrap:break-word;
}
</style>
